import "../index.scss";

import React from "react";
import { connect } from "react-redux";
import moment from "moment";
import _ from "lodash";
import Tooltip from "@/src/components/common/Elements/Tooltip/Tooltip";
import DeleteAction from "../../Modal/DeleteAction/DeleteAction";
import Axios from "Source/axiosPool";
import Actions from "./Actions/Actions";
import Links from "Components/common/Conversations/Fields/Links/Links";
import Editor from "Components/common/Conversations/Fields/Editor/Editor";
import Members from "Components/project/Conversations/Common/Members/Members";
import Message from "./Message/Message";
import Reply from "./Reply/Reply";
import DiscardChanges from "Components/common/DiscardChanges/DiscardChanges";
import NavigationBlocker from "Source/components/common/NavigationBlocker/NavigationBlocker";
import { showToast } from "Source/globalFunction";
import clsx from "clsx";

let keyTimer = ""
let fetchTimer = ""
let onNew = false
let isReady = false
let fromLookUp =  false
@connect(store => {
    return {
        conversations: store.conversations,
        project: store.project,
        loggedUser: store.loggedUser,
        notes: store.notes,

    }
})

class ViewConversation extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            totalCount: 0,
            allOldMsg: false,
            scrollHeight: 0,
            loading: false,
            direction: "",
            hasMore: 0,
            isActive: false,
            userWorkstreams:[],
            loaded:false,
            onstart:false,
            isReady:false

        }

        _.map(["handleNext",
            "fectWithTimeOut",
            "fetchNext",
            "handleClose",
            "setActiveDragDrop",
            "onDragOver",
            "setActiveDragDrop",
            "onDrop",
            "fetchWorkstreams",
            "onDiscardChanges",
            "handleDelete",
            "handleCloseReply",
            
        ], fn => {
            this[fn] = this[fn].bind(this);
        });
        this.activeDrag = 0
    }
    componentWillUnmount() {
        const {dispatch} = this.props
        this.setState({
            totalCount: 0,
            allOldMsg: false,
            scrollHeight: 0,
            loading: false,
            direction: "",
            hasMore: 0,
            loaded:false,
            onstart:false
        })
        dispatch({ type: "UPDATE_CONVERSATIONS_FIELD", field: "message", value: {} });
        dispatch({ type: "CONVERSATION_UPLOADED_FILE", files: [] })
        dispatch({ type: "CONVERSATION_FILE_INSERTED", bool: false })
    }
  
    shouldComponentUpdate(next) {
        const { conversations, dispatch, notes } = this.props
        if (!_.isEqual(next.conversations.selectedMessages, conversations.selectedMessages)
            || !_.isEqual(next.conversations.selected.id, conversations.selected.id)) {
                
           const onNew = !_.isEqual(next.conversations.selected.id, conversations.selected.id) && next.conversations.selected.id != null
           const hasMore = next.notes.Selected.details?next.notes.Selected.details.hasMore:0
           fromLookUp = next.notes.Selected.details?next.notes.Selected.details.action==='lookUp':false
           
           //on new selected conversation
           if (onNew) {
                this.fetchWorkstreams()
                this.setState({
                    allOldMsg: false,
                    totalCount: next.conversations.selected.total_count,
                    hasMore:hasMore,
                    loaded:false,
                    onstart:false,
                  
                })
                isReady = false
                setTimeout(() => {
                    const scrollHeight = $('#divElement').prop('scrollHeight')
                    const height = $('#divElement').height()
                    if (Math.ceil(height) >= scrollHeight) {
                        this.handleNext()
                    } else {
                        setTimeout(() => {
                                const ht = $('#divElement').prop('scrollHeight')
                                const inner = $('#divElement').height()                                                 
                                const val = hasMore?ht-(Math.ceil(inner)+20):ht -20
                                $('#divElement').animate({
                                    scrollTop: val
                                }, 2000);
                            }, 50);
                    }
                    isReady = true
                }, 2500);

            } else {
                //on message look up
                if(hasMore && fromLookUp) {
                    isReady = false
                    this.setState({
                        hasMore:1
                    },()=>{     
                        
                        setTimeout(() => {
                            const scrollHeight = $('#divElement').prop('scrollHeight')
                            const height = $('#divElement').height()
                            if (Math.ceil(height) >= scrollHeight) {
                                this.handleNext('up')     
                            } 
                            isReady = true
                        }, 2500)
                    })    
                }
            
            }
            keyTimer && clearTimeout(keyTimer)
            keyTimer = setTimeout(() => {
                const event = conversations.selectedEvents.filter(f => f.id)
                dispatch({ type: "UPDATE_CONVERSATIONS_SELECTED_EVENTS", events: event });
            }, 60000);

        }
        return true
    }

    handleNext(scroll = null) {
        const { conversations } = this.props
        const selected = _.cloneDeep(conversations.selectedMessages)
        let scrollAction = ""
        let params = {}
        if(scroll) {
            if(scroll==='up') {
                params = {
                    nextDate: selected.pop().dateAdded
                }

                scrollAction = 'up'
            } else {
                params = {
                    prevDate: selected[0].dateAdded
                }
                scrollAction = 'down'
            }
               this.setState({ direction: scrollAction })
                this.fectWithTimeOut(params)
            
        } else {
            if (selected.length < this.state.totalCount && selected.length >= 10 ) {
               
                if (this.state.hasMore && !this.state.loaded) {
                    params = {
                        nextDate: selected.pop().dateAdded
                    }
    
                    scrollAction = 'up'
                } else {
                    params = {
                        prevDate: selected[0].dateAdded
                    }
                    scrollAction = 'down'
                }
                this.setState({ direction: scrollAction })
                this.fectWithTimeOut(params)
    
    
            }
        }
      
    }
    onDiscardChanges(){
        const { dispatch,conversations } = this.props
        const selectedMessage = conversations.selectedMessages
        // UPDATE_CONVERSATIONS_SELECTED_MESSAGES
         dispatch({type:"UPDATE_CONVERSATIONS_SELECTED_MESSAGES",messages:selectedMessage.map(s=>{
                 delete s.forEdit
                 return s   
         })})
        showToast( "success", "Changes have been discarded" );
        $('#cancelEdit').modal('hide');
    }
    fetchWorkstreams(options = null){
        const { project, loggedUser } = this.props;
        let fetchUrl = `/api/workstream`;
        const params={
            projectId:project.Selected.id,
            page:1,
            userId:loggedUser.data.id,
            userRole:loggedUser.data.userRole,
            workstreamStatus:'Active',
            hasMembers: 1,
            section: 'conversation',
            ...(options ? { workstream: options } : {})
        }

        Axios.get(fetchUrl, params).then(c => {
            if(c) {
                const workstreamOptions = _(c.data.result)
                    .map(e => {
                        return { value: e.id, label: e.workstream, color: e.color, members:e.workstreamMembers};
                    }).value();
                
                this.setState({ ...this.state, userWorkstreams: workstreamOptions });
            }
        });
         
    }
    fectWithTimeOut(param) {
        fetchTimer && clearTimeout(fetchTimer)
        fetchTimer = setTimeout(() => {
            this.fetchNext(param)
        }, 1000);
    }
    fetchNext(params) {
        const { conversations, dispatch, loggedUser } = this.props
        const selected = conversations.selected
        let url = `api/conversation/getConversationListV2?linkType=notes&linkId=${selected.id}&page=1&projectId=${selected.projectId}`
        if (Object.keys(params).length) {
            let add = ''
            Object.keys(params).forEach(e => {
                add += `&${e}=${params[e]}`
            })
            if (add) {
                url += add
            }
        }
        // dispatch({ type: "SET_SCREEN_LOADER", Loading: true });
        this.setState({ loading: true })
        Axios.get(url, {})
            .then(response => {
                if (response) {
                    if(response.data.result.length === 0){
                        if(this.state.direction === 'up') {
                            this.setState({loaded:true})
                            dispatch({ type: "SET_CONVERSATIONS_LATEST", list: []})
                        } else {
                            this.setState({onstart:true})
                        }
                       
                    } else {
                        this.setState({ totalCount: response.data.count.total_count, hasMore: this.state.direction === 'up' && response.data.result.length > 0?1:0 })
                        const resultList = response.data.result.map(c => {
                            return {
                                ...c,
                                isSeen: c.seenComments.filter(f => f.userId === loggedUser.data.id).length > 0
                            }
                        }
                        ).reverse()
                        let messageList = [...resultList, ...this.props.conversations.selectedMessages]
                        let eventList = [...response.data.event?response.data.event:[], ...this.props.conversations.selectedEvents]
    
                        if (this.state.direction === 'up') {
                            messageList = [...this.props.conversations.selectedMessages, ...resultList]
                            eventList = [...this.props.conversations.selectedEvents, ...response.data.event?response.data.event:[]]
                        } 
    
                        dispatch({ type: "UPDATE_CONVERSATIONS_SELECTED_MESSAGES", messages: _.uniqBy(messageList,'id') });
                        dispatch({ type: "UPDATE_CONVERSATIONS_SELECTED_EVENTS", events: _.uniqBy(eventList, 'id') }); 
                    }
                  
                }
                this.setState({ loading: false })

                if (this.state.direction === 'up' && !fromLookUp) {
                    setTimeout(() => {
                        const ht = $('#divElement').prop('scrollHeight')
                        $('#divElement').animate({
                            scrollTop: ht + 500
                        }, 2000);
                    }, 100);
                }

                // dispatch({ type: "SET_SCREEN_LOADER", Loading: false });
            })
    }
    handleClose(isAdmin = false) {
       const{dispatch, conversations, notes, loggedUser}=this.props
       const uploadFiles = conversations.files.length
        if(uploadFiles>0) {
            $('#upload-cancel').modal('show')
        } else {
            this.setState({
                totalCount: 0,
                allOldMsg: false,
                scrollHeight: 0,
                loading: false,
                direction: "",
                hasMore: 0
            })
            let updated = notes.List.filter(u => u.id !== conversations.selected.id)
            if(conversations.selected.isArchived) {
                if ( ["favorites","archived"].indexOf(notes.Type) === -1) {
                    dispatch({ type: "SET_NOTES_LIST", list: updated });
                }
               
            }
            const  selected = conversations.selected
            const members = selected.tagged_users ? selected.tagged_users.filter(u => u.linkId === loggedUser.data.id) : []
            if(!isAdmin && members.length < 1 ) {
                dispatch({ type: "SET_NOTES_LIST", list: updated });
            }

            dispatch({ type: "SET_NOTES_SELECTED", Selected: {} });
            dispatch({ type: "UPDATE_CONVERSATIONS_SELECTED_MESSAGES", messages: [] });  
            dispatch({ type: "UPDATE_CONVERSATIONS_SELECTED", selected: {} });  
            dispatch({ type: "CONVERSATION_UPLOADED_STATUS", bool: true })
            dispatch({ type: "UPDATE_CONVERSATIONS_FIELD", field: "message", value: {} });
            dispatch({ type: "CONVERSATION_FILE_INSERTED", bool: false })
            dispatch({ type: "SET_CONVERSATIONS_MSG_SELECTED", selected: {}});
            dispatch({ type: "CONVERSATION_UPLOADED_FILE", files: []});
            
        }
       
    }

    onDragOver(e) {
        if (e) {
            e.preventDefault();
        }
        return false;
    }
    setActiveDragDrop(val) {
        if (val) {
            this.activeDrag += 1;
            this.setState({ isActive: this.activeDrag > 0 });
        } else {
            this.activeDrag -= 1;
            if (this.activeDrag === 0) {
                this.setState({ isActive: false });
            }
        }

    }
    onDrop(e) {
        const { dispatch } = this.props
        if (!e) {
            return;
        }

        e.preventDefault();
        this.activeDrag = 0;
        const droppedFiles = e.dataTransfer ? e.dataTransfer.files : [];
        let files = []
        for (let i = 0; i < droppedFiles.length; i++) {
            files.push(droppedFiles[i])
        }
        dispatch({ type: "CONVERSATION_UPLOADED_RAW", raw: files, loc: 'send' })

        setTimeout(() => {
            this.setState({ isActive: false });
            $('#conversation-droppedFiles').trigger('click')
        }, 1000)
    }
    handleDelete(){
        const {dispatch, conversations} = this.props;
        const msg = conversations.selectedMsg
        const url =`api/conversation/deleteComment/${msg.id}`
            Axios.delete(url,{}).then(res=>{
                if(res){
                    const selected= conversations.selectedMessages.map(s=>{
                        if(s.id === parseInt(res.data.id)) {
                            return {
                                ...s,
                                isDeleted:1,
                                conversationDocuments:[]
                            }
                        } else {
                            if(s.parent && (s.parent.id === parseInt(res.data.id))){
                                return {...s,parent:{...s.parent, isDeleted:1, }}
                            }
                            return s
                        }  
                    })
                    dispatch({ type: "UPDATE_CONVERSATIONS_SELECTED_MESSAGES", messages: selected });
                    dispatch({ type: "SET_CONVERSATIONS_MSG_SELECTED", selected: {} });
                    $(`#deletedMsgModal`).modal("hide");
                    showToast('success', 'Message deleted successfully!')
                } else{
                    showToast('success', 'Error on deleting message')
                }
            }) 
       
    }
    handleCloseReply(){
        const {dispatch} = this.props;
        dispatch({ type: "SET_CONVERSATIONS_MSG_SELECTED", selected: {} });
    }

   checkChanges = () => {
        const { conversations } = this.props

        // Check if editor has any text
        if (conversations.fields.message && Object.keys(conversations.fields.message).length) {
            const messsageJson = JSON.parse(conversations.fields.message);

            if (messsageJson.blocks && messsageJson.blocks.length) {
                const firstBlock = messsageJson.blocks[0];

                if(firstBlock.text.length > 0) {
                    return true;
                }
            }
        }

        return false;
    }

    IsJsonString(str) {
        try {
          JSON.parse(str);
        } catch (e) {
          return false;
        }
    
        return true;
    }

    render() {
        const {dispatch, conversations, project, handleArchived, loggedUser, scrollClassName } = this.props;
        const selected = conversations.selected;
        const messages = conversations.selectedMessages;
        const event = conversations.selectedEvents;
        const formatMessages = () => {
            let initial = [...event.map( e => ({ ...e, type: "event" })), ...messages.map( m => ({ ...m, type: "message" }))];
            let formatted = [];
            let basis5min = null;
            let basisDay = null;

            for (const [i, message] of initial.entries()) {
                let isBelow5mins = false;
                let isInNextDay = false;

                if (i === 0) {
                    if( message.type === "message" ) {
                        if (!basis5min) {
                            basis5min = message;
                        }
                    }

                    if (!basisDay) {
                        basisDay = message;
                        isInNextDay = true;
                    }
                } else {
                    /* 1 day basis */
                    if (basisDay) {
                        if (moment.duration(moment(moment(message.dateAdded).format("MM/DD/YYYY")).diff(moment(moment(basisDay.dateAdded).format("MM/DD/YYYY")))).days() >= 1) {
                            basisDay = message;
                            isInNextDay = true;

                            if( message.type === "message" ) {
                                basis5min = message;
                            }
                        } else {
                            /* 5 mins basis */
                            if( message.type === "message" ) {
                                const hasNew = event.filter(e => { return moment(e.dateAdded).isSame(message.dateAdded) && e.event === "New Message" })
                                
                                if (basis5min) {
                                    if (message.users.id === basis5min.users.id) {
                                        if (moment.duration(moment(message.dateAdded).diff(moment(basis5min.dateAdded))).minutes() < 5 && hasNew.length === 0) {
                                            isBelow5mins = true;
                                        } else {
                                            basis5min = message;
                                        }
                                    } else {
                                        basis5min = message;
                                    }
                                } else {
                                    basis5min = message;
                                }
                            }
                        }
                    }
                }

                formatted = [
                    ...formatted,
                    {
                        ...message,
                        ...isBelow5mins ? { below5mins: true } : {},
                        ...isInNextDay ? { inNextDay: true } : {}
                    }
                ];
            }

            return _.sortBy(formatted, "dateAdded");
        }

        const handleScroll = (e) => {     
            if (!onNew && isReady) {
                if (e.target.scrollTop === 0) {
                    if (messages.length < this.state.totalCount && !this.state.onstart) {
                        const params = {
                            prevDate: messages[0].dateAdded
                        }
                        this.setState({ direction: 'down' }) 
                        this.fectWithTimeOut(params)
                    } else {
                        if (!this.state.allOldMsg && messages.length>10) {
                            this.setState({ allOldMsg: true }, () => {
                                showToast('success', 'No more messages')
                            })
                        }
                    }
                } else if (this.state.hasMore > 0 && ((e.target.clientHeight + Math.ceil(e.target.scrollTop)+5) >= e.target.scrollHeight)  && !this.state.loaded) {
                    fromLookUp = false
                    
                    const params = {
                        nextDate: _.cloneDeep(_.orderBy(messages,["dateAdded"],["asc"])).pop().dateAdded
                    }

                    this.setState({ direction: 'up' })
                    this.fectWithTimeOut(params)
                }
            }

        }
        const handleOpenFile = (doc) => {    
           // window.open(window.location.origin + `/account#/projects/${project.Selected.id}/files?action=copy&file-id=${doc.id}`, '_blank');
           Axios.get(`/api/document/detail/${doc.id}`, {}).then(ret=>{
               if(ret){
                setTimeout(()=>{    
                    const documentObj = ret.data;
                    dispatch({ type: "SET_DOCUMENT_SELECTED", Selected: {...documentObj,  action: "VIEW"}});
                    $(`#documentViewerModal`).modal("show");
                },500)
               }
           })  
               
           
        }
        const openInfo = ()=>{
            dispatch({ type: "SET_CONVERSATIONS_TAB_SELECTED", selected: {id: "attachments", label: "Attachments"}})
            dispatch({ type: "SET_CONVERSATIONS_SHOW_INFO_MODAL", showInfoModal: true });
        }
      const IsJsonString=(str)=> {
            try {
                JSON.parse(str);
            } catch (e) {
                return false;
            }
    
            return true;
        }
        const files = _.sortBy(selected.notesTagDoc,'dateAdded').reverse()

        const members = selected.tagged_users ? selected.tagged_users.filter(u => u.linkId === loggedUser.data.id) : []
       
        const workstreamIlead = this.state.userWorkstreams.filter(f=>{
             const lead = f.members.filter(f=>f.assign==="responsible" && f.id === loggedUser.data.id)
            return lead.length >0})
        const isWsLead = selected.tagged_workstreams_notes? workstreamIlead.filter(w=> {
            return selected.tagged_workstreams_notes.map(t=>t.linkId).indexOf(w.value)>-1}):[] 
        const isProjectLead = project.Selected.leadId === loggedUser.data.id
        const isAdmin = loggedUser.data.userRole < 3 || isProjectLead || isWsLead.length>0 ;
        const hasMsgSelected = conversations.selectedMsg;
        const isAdminWithoutWslead = loggedUser.data.userRole < 3 || isProjectLead ;
        const isUpdated = this.checkChanges();

        return (
            <div>
                <div class="modal right fade conversation-modal viewConvo" id="view-conversation-form" data-backdrop="static" data-keyboard="false">
                    {Object.keys(selected).length > 0 && (
                        <div class="modal-dialog">
                            <div class={`modal-content ${members.length <= 0 || selected.isArchived ? "disabled" : ""}`}
                                onDragEnter={() => { this.setActiveDragDrop(true) }}
                                onDragOver={this.onDragOver}
                                onDragLeave={() => { this.setActiveDragDrop(false) }}
                                onDrop={this.onDrop}>

                                {this.state.isActive && (
                                    <div class="dnd-overlay-container">
                                        <div class="dnd-overlay">Drop files here</div>
                                    </div>
                                )}

                                <div class="modal-header">
                                    <Actions selected={selected} handleArchived={handleArchived} onClose={this.handleClose} isAdmin={isAdmin} isAdminWithoutWslead={isAdminWithoutWslead} />
                                </div>

                                <div class="modal-body">
                                    <div class="conversation-header">
                                        <div class="header-title">
                                            <div class="header-subject">
                                                <h4>{selected.note}</h4>
                                            </div>
                                            <div class="header-members">
                                                <Members note={selected} />
                                            </div>
                                        </div>
                                        <div class="header-links">
                                            <Links projectId={project.Selected.id} workstreams={(selected.tagged_workstreams_notes || []).filter(w => w.workstream).map(w => ({ value: w.workstream.id, label: w.workstream.workstream, color: w.workstream.color }))}  userWorkstreams={this.state.userWorkstreams}/>

                                            <div class="header-attachments">
                                                {files.slice(0, 2).map(file => {
                                                    if (!file.document || !file.document.origin) return null;
                                                    const origin = file.document.origin;
                                                    const name = origin.length > 30 ? origin.substring(0, 12) + '...' + origin.substring(origin.length - 15, origin.length) : origin;
                                                    return (
                                                        <div key={`${file.document.id}`} >
                                                            <a href={`${window.location.origin}/account#/projects/${project.Selected.id}/files?action=copy&file-id=${file.document.id}`}  target="_blank"   data-tooltip-id={`document-file-${file.document.id}`} onClick={(e)=>{e.preventDefault(); handleOpenFile(file.document)}}>
                                                                <i class="material-icons">description</i>
                                                            </a>
                                                            <Tooltip id={`document-file-${file.document.id}`} place="bottom" effect="solid">
                                                                {name}
                                                            </Tooltip>
                                                        </div>
                                                    )
                                                })}
                                                {files.length > 2 && (
                                                    <React.Fragment>
                                                        <span   data-tooltip-id={`fileCounter${selected.id}_tooltip`} 
                                                             class="fileCounter" 
                                                             style={{cursor: 'pointer'}}
                                                            onClick={openInfo}> 
                                                            +{files.length - 2}
                                                        </span>
                                                        <Tooltip id={`fileCounter${selected.id}_tooltip`} place="bottom" effect="solid" 
                                                         clickable={true} 
                                                         delayHide={100}
                                                         offset={{left: 60}}
                                                         textColor={'white'}
                                                         >
                                                        {files && files.filter(m => m && m.document && m.document.origin).slice(2, files.length).map((m, i) => {
                                                            const origin = m.document.origin;
                                                            const name = origin.length > 30 ? origin.substring(0, 12) + '...' + origin.substring(origin.length - 15, origin.length) : origin;
                                                            return (
                                                                <p key={`fileCounter${selected.id}_${i}`} class='linkContainer'>
                                                                    <a  class='link' href={`${window.location.origin}/account#/projects/${project.Selected.id}/files?action=copy&file-id=${m.document.id}`}  target="_blank" 
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            handleOpenFile(m.document);
                                                                        }}>
                                                                        {name}
                                                                    </a>
                                                                </p>
                                                            )
                                                        })}
                                                        </Tooltip>
                                                    </React.Fragment>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div id="divElement" className={clsx(' conversation-list hasScroll', scrollClassName)} onScroll={(e)=>{e.preventDefault();handleScroll(e)}}>
                                        {/* <Activity message={ selected } /> */}
                                        {this.state.loading && this.state.direction === 'down' &&
                                            <div class="spinner" />
                                        }
                                        {formatMessages().map((c, i) => {
                                            return (
                                                <div>
                                                    <Message message={c} projectId={project.Selected.id} index={i} prev={i > 1 ? formatMessages()[i - 1] : null} openFile={handleOpenFile}  isAdmin={isAdmin}/>
                                                </div>
                                            )
                                        })

                                        }
                                        {this.state.loading && this.state.direction === 'up' &&
                                            <div class="spinner" />
                                        }
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    {selected.isArchived ?
                                        <div class="msgNoAccess">
                                            <p><i class="material-icons-outlined">info</i>This conversation has been archived</p>
                                        </div>
                                        :
                                        <span>
                                            {selected.isLeave && !selected.softUpdate ? 
                                                <div class="msgNoAccess">
                                                    <p>You left the conversation.</p>
                                                </div> :
                                                <span>
                                                    {members.length > 0 ? 
                                                     <React.Fragment>
                                                        {(hasMsgSelected 
                                                         && Object.keys(hasMsgSelected).length>0 
                                                         && hasMsgSelected.action 
                                                         && hasMsgSelected.action ==='reply') 
                                                         && <Reply message={conversations.selectedMsg} onClose={this.handleCloseReply} onReply />} 
                                                         <Editor actionType="send"/> 
                                                     </React.Fragment>
                                                    :
                                                        <div class="msgNoAccess">
                                                            <p><i class="material-icons-outlined">info</i>You are not a member of this conversation. Please check the settings.</p>
                                                        </div>
                                                    }
                                                </span>
                                            }

                                        </span>
                                    }
                                </div>
                            </div>
                        </div>
                    )}
                </div>
                <DiscardChanges 
                onCancel={this.onDiscardChanges} 
                id={'cancelEdit'} 
                message={`Changes will not be saved. Do you wish to proceed?`} 
                okBtn={'Proceed'}/>
                 <DeleteAction 
                 onDelete={this.handleDelete} 
                 title={'Delete this Message'}
                 id={'deletedMsgModal'}
                 message={'This cannot be undone. Do you wish to proceed?'}
                 okBtn={'Delete'}/>
                <NavigationBlocker navigationBlocked={isUpdated}/>
            </div>
        );
    }
}

export default ViewConversation;